import { createApp } from 'vue'
import DeliveryCard from './DeliveryCard'

const el = '.kb-component--delivery-card'

export default function (Store) {
    const DOM = document.querySelectorAll(el)

    if (DOM.length) {
        DOM.forEach((DeliveryCardDOM) => {
            const type = DeliveryCardDOM.dataset.type
            const svgIcon = DeliveryCardDOM.dataset.svgIcon
            const component = createApp(DeliveryCard, { type, svgIcon }).use(
                Store
            )
            component.mount(DeliveryCardDOM)
        })
    }
}
